import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    DriverTachogramDownloadResult,
    VehicleTachogramDownloadResult,
    getDriverTachogramDownloads,
    getVehicleTachogramDownloads,
} from "../services/tachogramDownloadService";

export interface TachogramDownloadState {
    driverDownloads: DriverTachogramDownloadResult[];
    vehicleDownloads: VehicleTachogramDownloadResult[];
    driverFilesLoading: boolean;
    vehicleFilesLoading: boolean;
}

export const initialState: TachogramDownloadState = {
    driverDownloads: [],
    vehicleDownloads: [],
    driverFilesLoading: false,
    vehicleFilesLoading: false,
};

export const fetchDriverTachogramDownloads = createAsyncThunk(
    "tachogramDownload/fetchDriverDownloads",
    async() => {
        return await getDriverTachogramDownloads();
    }
);

export const fetchVehicleTachogramDownloads = createAsyncThunk(
    "tachogramDownload/fetchVehicleDownloads",
    async() => {
        return await getVehicleTachogramDownloads();
    }
);

export const tachogramDownloadSlice = createSlice({
    name: "tachogramDownload",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchDriverTachogramDownloads.pending, (state) => {
                state.driverFilesLoading = true;
            })
            .addCase(
                fetchDriverTachogramDownloads.fulfilled,
                (state, action) => {
                    state.driverFilesLoading = false;
                    state.driverDownloads = action.payload;
                }
            )
            .addCase(fetchDriverTachogramDownloads.rejected, (state) => {
                state.driverFilesLoading = false;
            })
            .addCase(fetchVehicleTachogramDownloads.pending, (state) => {
                state.vehicleFilesLoading = true;
            })
            .addCase(
                fetchVehicleTachogramDownloads.fulfilled,
                (state, action) => {
                    state.vehicleFilesLoading = false;
                    state.vehicleDownloads = action.payload;
                }
            )
            .addCase(fetchVehicleTachogramDownloads.rejected, (state) => {
                state.vehicleFilesLoading = false;
            });
    },
});

export const tachogramDownloadReducer = tachogramDownloadSlice.reducer;
